import React from 'react'
import { Box, Button } from '@mui/material'
import { ChevronLeftTwoTone, ChevronRightTwoTone } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  root: {
    '& > *:not(:last-child)': {
      marginRight: spacing(1)
    }
  },
  onward: {
    '& .MuiButton-root': {
      textTransform: 'capitalize'
    }
  }
}))

const NavButtons = ({
  activeStep,
  maxSteps,
  onBack,
  onNext,
  onFinish,
  'data-test': dataTest = 'lpq-stepper-nav'
}) => {
  const classes = useStyles()

  const isFirstStep = () => activeStep === 0

  const isLastStep = () => activeStep === maxSteps - 1

  const onwardLabel = () => (isLastStep() ? 'finish' : 'next')

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='flex-end'
      className={classes.root}
    >
      {!isFirstStep() && (
        <Button
          variant='outlined'
          onClick={onBack}
          disableElevation
          aria-label='back'
          data-test={`${dataTest}-back-button`}
        >
          <ChevronLeftTwoTone />
        </Button>
      )}
      <Button
        variant='contained'
        onClick={isLastStep() ? onFinish : onNext}
        color='primary'
        disableElevation
        endIcon={<ChevronRightTwoTone />}
        className={classes.onward}
        data-test={`${dataTest}-onward-button`}
      >
        {onwardLabel()}
      </Button>
    </Box>
  )
}

export default NavButtons
